import { Money } from '@dreryk/money-common-api';

import { TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AdvancePaymentRequiredAmountForLinkTextViewProps = Readonly<{ requiredAmount: Money }>;

export const AdvancePaymentRequiredAmountForLinkTextView = (
   props: AdvancePaymentRequiredAmountForLinkTextViewProps
): JSX.Element => {
   return (
      <TextView testId={'advancePaymentRemainingAmount'} label={translationKeys.remainingAmountForThatLink}>
         {priceFormatter(
            props.requiredAmount.asNumber(),
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: true,
               },
            })
         )}
      </TextView>
   );
};
